let t = key => key; // fallback vertaalfunctie

function initTranslator(translatorFn) {
  t = translatorFn;
}

module.exports = {
  /************************************
   * Development configuration
  *************************************/
  // url: {
  //   api: `http://localhost:8000`,
  //   login: `http://localhost:8080`,
  //   main: `http://localhost:8080`,
  //   dashboard: `http://localhost:8080`,
  //   cdn: `http://localhost/kyanocdn`,
  //   liveapp: `localhost:8081`
  // },
  // cookiedomain: "localhost",

  // allowedredirectdomains: ["localhost:8080", "localhost:8081"],

  /************************************
   * Staging configuration 
  *************************************/

  url: {
    api: `https://api.staging.kyano.app`,
    login: `https://staging.kyano.app`,
    main: `https://staging.kyano.app`,
    dashboard: `https://staging.kyano.app`,
    cdn: `https://api.staging.kyano.app`,
    liveapp: `staging-app.kyano.app`
  },
  cookiedomain: "staging.kyano.app",

  allowedredirectdomains: ["staging.kyano.app"],

  // Live configuration
  /************************************
   * Live configuration
   * - Verwijder alle configs die niet nodig zijn hierboven.
  *************************************/

  // allowedredirectdomains: [
  //   "staging.kyano.app",
  // ],

  /************************************
   * CONFIG APP
  *************************************/

  initTranslator,
  getTranslator: () => t,

  rules: {
    required: [v => !!v || "Required field!"],
    name: [
      v => !!v || "Required field!",
      value => (value && !(value.length > 100)) || "Maximum 100 characters"
    ],
    email: [
      v => !!v || "Email address is not valid!",
      v => /.+@.+\..+/.test(v) || "Invalid email address!"
    ],
    phonenumber: [
      v => !!v || "Phone number is not valid!",
      v =>
        /^[+]?[\s./0-9]*[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/g.test(v) ||
        "Invalid phone number!"
    ],
    number: [
      v => !!v || "This field is required",
      v => /^\d+(\.\d+)?$/.test(v) || "Please enter a valid number"
    ]
  },

  content: {
    invalid_url: () => t("invalid_url")
  },

  regex: {
    name: /^[a-zA-Z -]{2,50}$/,
    mail: /^.+@.+$/,
    phonenumber: /^\+?[1-9]\d{3,14}$/,
    password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!#%*?&])[A-Za-z\d@$!#%*?&]{8,64}$/
  },

  dateformat: {
    weekday: "short",
    year: "numeric",
    day: "numeric",
    month: "long",
    hour: "numeric",
    minute: "numeric"
  }
};
